<template>
    <v-card class="pt-4 mt-3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" class="mx-4 mb-3"
                      label="Suchen" dense hide-details outlined clearable/>
        <v-data-table :headers="headers" :items="massDelete.deleteableSpieler" :search="search">
            <template v-slot:header.actions="{ header }">
                <v-checkbox v-model="selectAll" @click.stop small class="mt-0" hide-details
                            :disabled="search!=='' && search!==null">
                    <template v-slot:label>
                        <span style="font-size: 12px; width: 110px">alle
                            auswählen <span style="font-size: 12px"
                        v-if="search!=='' && search!==null">(bitte Filter löschen)</span>
                        </span>
                    </template>
                </v-checkbox>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-checkbox v-model="item.selected" :disabled="item.activeRoles!=='-'"/>
            </template>
            <template v-slot:item.nachname="{ item }">
                <div class="text-no-wrap">
                    <v-icon @click="openInfo(item)" class="mr-1">mdi-information</v-icon> {{item.nachname}}
                </div>
            </template>
        </v-data-table>
        <spieler-info :spieler="spielerInfo"/>
        <div class="text-right px-4 pb-4 pt-2">
            <v-btn @click="deleteConfirm()" color="primary" :disabled="noOfPlayersToDelete===0">
                <v-icon class="mr-1">mdi-delete</v-icon>
                Ausgewählte Löschen</v-btn>
        </div>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="deleteSelected" query-parameter="massDeletePlayer">
        </confirm-dialog>
        <v-dialog v-model="massDelete.inProgress" persistent width="466">
            <v-card width="466">
                <v-card-title>Daten werden gelöscht</v-card-title>
                <v-card-text>Bitte um etwas Geduld, die gewünschten Daten werden gelöscht (bitte dieses Fenster nicht verlassen)!
                    <v-progress-linear color="primary" class="my-3"
                                         :value="massDelete.getProgress()"/>
                    {{massDelete.progress.deleted}} von {{massDelete.progress.total}}
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import SpielerInfo from "@/views/spielerTabelle/spielerInfo/spielerInfo";
import RouterServices from "@/utilities/services/router/routerServices";
import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
import ConfirmDialog from "@/components/elements/confirmDialog";
import {Kugel} from "@/services/data/kugeln/kugel";
export default {
    name: "mass-delete-list",
    components: {ConfirmDialog, SpielerInfo},
    props: ['massDelete'],
    computed: {
        noOfPlayersToDelete(){ return this.massDelete.getNumberOfSelectedForDelete()}
    },
    data: () => ({
        headers: [
            {text: 'Nachname', value: 'nachname'},
            {text: 'Vorname', value: 'vorname'},
            {text: 'Geschlecht', value: 'geschlechtLang'},
            {text: 'Inaktiv seit', value: 'inaktivSeit'},
            {text: 'Letzter Verein', value: 'lastMembership.lvVereinId'},
            {text: 'Letzte PassNr', value: 'lastMembership.passNr'},
            {text: 'Aktive Ausweise', value: 'activeRoles'},
            {text: 'actions', value: 'actions', sortable: false},
        ],
        selectAll: false,
        spielerInfo: null,
        search: null,
        confirmDelete: {
            open: false,
            question: '',
            item: null,
            header: 'Spieler löschen'
        },
    }),
    methods: {
        openInfo(spieler){
            this.spielerInfo = spieler
            this.spielerInfo.passNr = SPIELER_MEMBERSHIP_HANDLER.getLastValidPassNr(spieler.memberships).regular
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'action', 'spielerInfo' )
        },
        deleteConfirm(){
            this.confirmDelete.question = this.noOfPlayersToDelete === 1 ?
                'Möchtest du den ausgewählten Spieler endgültig und unwiderruflich löschen?':
                'Möchtest du die ' + this.noOfPlayersToDelete + ' ausgewählten Spieler endgültig und unwiderruflich löschen?'
            this.confirmDelete.open = true;
        },
        deleteSelected(reply){
            if ( reply ) {
                this.massDelete.deleteSelected()
            }
            this.confirmDelete.open = false;
        },
    },
    watch: {
        selectAll(to){ this.massDelete.setSelected(to) },
        search(to, from) {
            if ( to && !from ) { this.selectAll=false }
        },
    }
}
</script>

<style scoped>

</style>